import { Customer } from "@main/customers/models/Customer";
import { Pet } from "@main/pets/models/Pet";
import { Room } from "@main/rooms/models/Room";

export class Booking {
    public id: number;
    public created_at: string;
    public updated_at: string;
    public deleted_at: string;
    public reference: string;
    public start_date_time: string;
    public end_date_time: string;
    public price_per_day: number;
    public observation: string;
    public total_price: number;
    public customer: Customer;
    public pets: Pet[];
    public rooms: Room[];
    public cancelled: boolean;
    public checked_in: boolean;
    public checked_out: boolean;


    constructor() {
        this.id = 0;        
        this.created_at = '';
        this.updated_at = '';
        this.deleted_at = '';
        this.reference = '';
        this.start_date_time = '';
        this.end_date_time = '';
        this.price_per_day = 0;
        this.observation = '';
        this.total_price = 0;
        this.customer = new Customer();
        this.pets = [];
        this.rooms = [];
        this.cancelled = false;
        this.checked_in = false;
        this.checked_out = false;
    }
}